import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';

import { Slide } from 'react-slideshow-image';
import SlideShow from './SlideShow'

import '../css/OpenSlideShow.css';

class OpenSlideShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_lang: this.props.lang,
      startAnimate: false,
      slideImages: ["/assets/mainpage_home1-1.webp", "/assets/mainpage_home1-2.webp", "/assets/mainpage_home1-3.png"],
      slideTitle: {
        "zh": ["AI Robots, Ready to Work.", "AI Robots, Ready to Work.", "AI Robots, Ready to Work."], 
        "en": ["AI Robots, Ready to Work.", "AI Robots, Ready to Work.", "AI Robots, Ready to Work."], 
        "ja": ["AI Robots, Ready to Work.", "AI Robots, Ready to Work.", "AI Robots, Ready to Work."]},
      slideContent: {
        "zh": ["Nexuni 耐思尼致力於推動 AI 機器人的落地，解決產業缺工問題。", "我們是 Universal Robots 認證的 Solution Provider以及Distributor，若有機器手臂解決方案的開發需求或採購，請聯絡我們。", "我們是 NVIDIA Inception 新創計畫成員，並且深度整合 NVIDIA 的軟硬體平台來開發 AI 機器人。"], 
        "en": ["We develop AI-powered robots designed for real-world deployment, focusing on solving industrial labor shortages through physical AI.", "We are a certified Solution Provider and Distributor for Universal Robots. If you have development or procurement needs for robotic arm solutions, please contact us.", "We are a member of the NVIDIA Inception startup program and deeply integrate NVIDIA's hardware and software platforms to develop AI robots."], 
        "ja": ["NexuniはAIロボット技術の導入を推進し、産業界の労働力不足を解決することに取り組んでいます。", "当社はUniversal Robotsの認定ソリューションプロバイダーおよび販売代理店です。ロボットアームソリューションの開発や購入に関するご要望がございましたら、お気軽にお問い合わせください。", "当社はNVIDIA Inceptionスタートアッププログラムのメンバーであり、NVIDIAのハードウェアおよびソフトウェアプラットフォームを深く統合してAIロボットを開発しています。"]},
      slideAction: [""]
    }
  }

  componentDidMount() {
    this.setState({
      startAnimate: true
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ current_lang: nextProps.lang });
    }
  }
  
  render() {

        return (
          <>
            <div className={"opening_section "+this.state.current_lang}>

                <div className="slide_area"
                  style={{
                    animation: "fade-in 3s ease 3.5s forwards"
                  }}>
                  <SlideShow version={"v2_"} lang={this.state.current_lang} title={this.state.slideTitle[this.state.current_lang]} content={this.state.slideContent[this.state.current_lang]} action={this.state.slideAction} img={this.state.slideImages} img_num={this.state.slideImages.length} arrow_flag={true} logo_flag={false}/>
                </div>

                <div className="opening_area_x_logo">
                  <img id="opening_area_x_logo_l" src="/assets/mainpage_nexuni_opening_l.svg" alt="blk-r" 
                    style={{
                      animation: "move-right 1.5s ease 0s forwards, fade-out 3s ease 0.75s forwards"
                    }}/>
                  <img id="opening_area_x_logo_r" src="/assets/mainpage_nexuni_opening_r.svg" alt="blk-l" 
                    style={{
                      animation: "move-left 1.5s ease 0s forwards, fade-out 3s ease 0.75s forwards"
                    }}/>
                </div>

                <div className="opening_area_nexuni_logo">
                  <img id="opening_area_nexuni_logo_n1" src="/assets/mainpage_nexuni_n.svg" alt="n" 
                    style={{
                      animation: "fade-in 3s ease 1.5s forwards, fade-out 0.5s ease 3s forwards"
                    }}/>
                  <img id="opening_area_nexuni_logo_e" src="/assets/mainpage_nexuni_e.svg" alt="e" 
                    style={{
                      animation: "fade-in 3s ease 1.8s forwards, fade-out 0.5s ease 3s forwards"
                    }}/>
                  <img id="opening_area_nexuni_logo_x" src="/assets/mainpage_nexuni_x.svg" alt="x" 
                    style={{
                      animation: "fade-in 3s ease 2.1s forwards, fade-out 0.5s ease 3s forwards"
                    }}/>
                  <img id="opening_area_nexuni_logo_u" src="/assets/mainpage_nexuni_u.svg" alt="u" 
                    style={{
                      animation: "fade-in 3s ease 2.4s forwards, fade-out 0.5s ease 3s forwards"
                    }}/>
                  <img id="opening_area_nexuni_logo_n2" src="/assets/mainpage_nexuni_n.svg" alt="n" 
                    style={{
                      animation: "fade-in 3s ease 2.7s forwards, fade-out 0.5s ease 3s forwards"
                    }}/>
                  <img id="opening_area_nexuni_logo_i" src="/assets/mainpage_nexuni_i.svg" alt="i" 
                    style={{
                      animation: "fade-in 3s ease 3s forwards, fade-out 0.5s ease 3s forwards"
                    }}/>
                </div>

            </div>
          </>
        ) 
  }
}
export default OpenSlideShow;


// import React from 'react';
// import { Slide } from 'react-slideshow-image';

// const properties = {
//   duration: 5000,
//   transitionDuration: 500,
//   infinite: true,
//   indicators: true,
//   arrows: true,
//   onChange: (oldIndex, newIndex) => {
//     console.log(`slide transition from ${oldIndex} to ${newIndex}`);
//   }
// }

// const Slideshow = () => {
//     return (
//       <div className="slide-container">
//         <Slide {...properties}>
//           <div className="each-slide">
//             <div style={{'backgroundImage': `url(${slideImages[0]})`}}>
//               <span>Slide 1</span>
//             </div>
//           </div>
//           <div className="each-slide">
//             <div style={{'backgroundImage': `url(${slideImages[1]})`}}>
//               <span>Slide 2</span>
//             </div>
//           </div>
//           <div className="each-slide">
//             <div style={{'backgroundImage': `url(${slideImages[2]})`}}>
//               <span>Slide 3</span>
//             </div>
//           </div>
//         </Slide>
//       </div>
//     )
// }
